<template>
  <div>
    <van-dialog
      v-model="show"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <div class="text-right" @click="showFn">
        <van-icon name="cross" size="0.4rem" color="#666" />
      </div>
      <div class="txt">
        提示
      </div>
      <div class="title">
        <p>您存在一笔在途的分期记录，请前往处理</p>
        <!-- <p class="mt6">是否继续？</p> -->
      </div>
      <!-- <van-row class="mt10 applyInfo">
        <van-col span="12">借款金额</van-col>
        <van-col span="12">{{ loanData.applyAmt }}</van-col>
        <van-col span="12">借款期限</van-col>
        <van-col span="12"
          >{{ loanData.applyTnr }}{{ loanData.applyTnrTyp == 'M' ? '个月' : '天' }}</van-col
        >
        <van-col span="12">申请时间</van-col>
        <van-col span="12">{{ loanData.applyDt }}</van-col>
        <van-col span="12">失效时间</van-col>
        <van-col span="12">{{ loanData.validDt }}</van-col>
      </van-row> -->
      <div class="mt10" @click="keepLoan" style="display: flex;justify-content: center;">
        <van-button style="width: 50%;" size="large" type="info" block round>确认前往</van-button>
      </div>
      <!-- <div class="mt10">
        <van-button round plain block type="primary" color="#4D7BFE" @click="cancelApply"
          >取消借款</van-button
        >
      </div> -->
    </van-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import { Col, Row, Button, Icon } from 'vant'
import { cancelApplyApi, getBorrowFaceTokenApi } from '@/apis/borrow'
import { getScanFaceUrlApi } from '@/apis/credit'

import { mapState } from 'vuex'

Vue.use(Col)
Vue.use(Row)
Vue.use(Button)
Vue.use(Icon)
export default {
  props: {
    loanData: {
      type: Object,
    },
  },
  data() {
    return {
      show: false,
      faceBackUrl: window.location.origin,
    }
  },
  created() {},
  computed: {
    ...mapState({
      loanNo: (state) => state.borrow.loanNo,
      applySeq: (state) => state.borrow.applySeq,
    }),
  },
  methods: {
    showFn() {
      this.show = false
    },
    keepLoan() {
      this.$emit('keepLoan', true)
      return;
      switch (this.loanData.inSts) {
        case 13:
          // 刷脸
          getBorrowFaceTokenApi({
            applySeq: this.loanData.applySeq || this.applySeq,
            callbackUrl: this.faceBackUrl + '/face-result?type=borrow',
          }).then((result) => {
            if (result.code === 200) {
              this.$store.commit('SET_FACE_TOKEN', result.data.faceToken)
              getScanFaceUrlApi(result.data.faceToken).then((r) => {
                window.location.href = r.data.originalUrl
              })
            }
          })
          break
        case 10:
          this.$router.push('/apply-info')
          break
        case 11:
          this.$router.push('/invoice-info')
          break
        case 12:
          this.$router.push('/upload-certificate')
          break
        case 20:
          this.$router.push('/face-recognition')
          break
        case 80:
          this.$router.push('/confirm-borrow')
          break
        case 130: // 去公证
            this.$router.push('/notarizationApply')
            break
        case 131: // 公证失败 
          this.$router.push('/notarizationResult')
          break
        case 140: // 支付首付款
          try {
            if(this.loanData.fstPayRecord.status == '150') {
              this.$router.push('/paymentResult')
              return
            }
          } catch (error) {
            
          }
          
          this.$router.push({
            path: '/downPayment',
            query: {
              amount: Number(this.loanData.downPayment)
            }
          })
          break
        case 141: // 首付款失败
          this.$router.push('/paymentResult')
          break
        case 150 || 200: // 待放款 || 放款成功
          this.$router.push('/approvel-pass-result')
          break
        case 300: // 放款失败
          this.$router.push('/approvel-refuse-result')
          break
        case 500:
          this.$router.push('/face-recognition')
          break
        default:
          // 申请借款页面
          this.$router.push({
            path: '/borrow-info',
            query: {
              id: this.loanData.id
            }
          })
          break
      }
    },
    cancelApply() {
      cancelApplyApi(this.loanData.loanNo).then((res) => {
        if (res.code === 200) {
          this.show = false
          this.$store.commit('SET_LOANNO', '')
          this.$common.toast(res.data.msg)
          this.$parent.getLimitVariety()
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .van-dialog {
  padding: 0.4rem;
  width: 6rem;
  font-size: 0.28rem;
  position: relative;
}
.txt {
  width: 6rem;
  // position: absolute;
  text-align: center;
  // top: 0.48rem;
  font-size: 0.35rem;
}
.title {
  font-size: 0.32rem;
  //border-bottom: 1px solid #666;
  padding: 0.4rem 0;
}
.applyInfo {
  /deep/ .van-col {
    margin-bottom: 0.16rem;
  }
  /deep/ .van-col:nth-child(even) {
    text-align: right;
  }
}
</style>
